import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message, Button, Select } from 'antd'
import MyRadio from '../../components/forms/radio'
import MyDatePicker from '../../components/forms/datePicker'

const AddJobFairSlotSlot = (props) => {
    const [formValue, setFormValue] = useState({
        campus: 1,
        slot_type: 2,
        date: '',
        venue_ids: []
    })

    const [venueOptions, setVenueOptions] = useState([])
    const [errorMsg, setErrorMsg] = useState({})

    const getVenueList = (campus) => {
        axios.post('/admin/venue/list', {
            campus: campus,
            slot_type: 2,
            per_page: 1000
        }).then(res => {
            if (res.errcode === 0) {
                const list = res.data.list || []
                setVenueOptions(
                    list.map(item => ({
                        label: item.name,
                        value: item.id
                    }))
                )
            }
        })
    }

    useEffect(() => {
        getVenueList(formValue.campus)
    }, [formValue.campus])

    const handleSubmit = () => {
        setErrorMsg({})
        if (!formValue.date) {
            setErrorMsg({ dateEmpty: '日期不能为空' })
            return false
        }
        if (!formValue.venue_ids || formValue.venue_ids.length === 0) {
            setErrorMsg({ venueEmpty: '请选择展位' })
            return false
        }

        axios.post('/admin/event_slot/add', {
            campus: formValue.campus,
            slot_type: 2,
            date: formValue.date,
            venue_ids: formValue.venue_ids
        })
        .then(function (response) {
            if (response.errcode === 0) {
                message.success('创建成功！')
                props.getSlotData()
            }
        })
        .catch(function (error) {
            console.error('请求失败：', error)
        })
    }

    const handleOk = () => {
        const isOk = handleSubmit()
        if (isOk !== false) { handleCancel() }
    }

    const handleNext = () => {
        handleSubmit()
        setFormValue({
            campus: formValue.campus,
            slot_type: 2,
            date: formValue.date,
            venue_ids: []
        })
    }

    const handleCancel = () => {
        setErrorMsg({})
        setFormValue({})
        props.isCancel()
    }

    return (
        <Modal
            title="创建双选会资源"
            width='800px'
            open={props.isOpen}
            onCancel={handleCancel}
            maskClosable={false}
            footer={[
                <Button key='cancel' onClick={handleCancel}>取消</Button>,
                <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
                <Button key='ok' type="primary" onClick={handleOk}>创建</Button>
            ]}
        >

            <MyRadio
                id='campus'
                label='所属校区'
                options={[
                    { label: '兰州职业技术学院', value: 1 },
                    { label: '雁儿湾校区', value: 2 },
                    { label: '桃林校区', value: 3 }
                ]}
                defaultValue={1}
                value={formValue.campus}
                onChange={(updater) => {
                    setFormValue(prev => {
                        const next = updater(prev)
                        return {
                            ...next,
                            venue_ids: []
                        }
                    })
                }}
            />

            <MyDatePicker
                id="date"
                required
                label="日期"
                placeholder="请选择日期"
                value={formValue.date}
                onChange={setFormValue}
                errorMsg={errorMsg.dateEmpty}
                styles={{ width: '100%' }}
            />

            <div style={{ marginTop: 16 }}>
                <div>选择展位(可多选)</div>
                <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="请选择展位"
                    value={formValue.venue_ids}
                    onChange={(val) => {
                        setFormValue({
                            ...formValue,
                            venue_ids: val
                        })
                    }}
                    options={venueOptions}
                />
                <div style={{ color: 'red' }}>{errorMsg.venueEmpty}</div>
            </div>

        </Modal>
    )
}

export default AddJobFairSlotSlot
